<template>
    <DCard
        class="envelope-details"
        padding
    >
        <div>
            <span>{{ __('tools.emails.modal.from') }}:</span>
            <span>{{ senders }}</span>
        </div>
        <div>
            <span>{{ __('tools.emails.modal.subject') }}:</span>
            <span>{{ sampleData?.subject }}</span>
        </div>
    </DCard>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    sampleData: {
        type: Object,
        default: () => ({})
    }
})

const senders = computed(() => {
    return (props.sampleData?.from ?? []).map((sender) => `${sender.name} <${sender.address}>`).join('; ')
})
</script>

<style lang="scss" scoped>
.envelope-details div > span {
    &:first-child {
        font-weight: bold;
    }
}
</style>
